(function () {
	'use strict';
	var app = angular.module('bmsApp',
		[
			'ngMaterial',
			'templates',
			'ngAnimate',
			'ncy-angular-breadcrumb',
			'bmsApp.global',
			'bmsApp.user',
			'bmsApp.dashboard',
			'bmsApp.settings',
			'bmsApp.calendar',
			'bmsApp.crm',
			'bmsApp.employee',
			'bmsApp.responses',
			'bmsApp.marketing',
			'bmsApp.accounting',
			'bmsApp.sm',
			'bmsApp.directives',
			'angularValidator',
			'bmsApp.state',
			'bmsApp.file',
			'bmsApp.fees',
			'bmsApp.ticket',
			'bmsApp.geocode',
			'bmsApp.audit',
			'bmsApp.zone',
			'bmsApp.reports',
			'bmsApp.resource',
			'bmsApp.instantMessaging',
			'ui.router',
			'ngTable',
			'ngIdle',
			'bmsApp.config',
			'bmsApp.taxHelper',
			'angularMoment',
			'angular.chosen',
			'ngSanitize',
			'ui.bootstrap',
			'ui.bootstrap.modal',
			'ui.bootstrap.contextMenu',
			'filters',
			'converter.distance',
			'ngBootbox',
			'ui.calendar',
			'angular-jquery-validate',
			'optionsDisabled',
			'cgNotify',
			'ng-currency',
			'angular.filter',
			'rzModule',
			'easypiechart',
			'vAccordion',
			'ngCookies',
			'jlareau.pnotify',
			'countTo',
			'ng-slide-down',
			'dndLists',
			'ui.timepicker',
			'720kb.tooltips',
			'ordinal',
			'mgcrea.bootstrap.affix',
			'ngMaterial',
			'ngDragDrop',
			'ngImgCrop',
			'ngjsColorPicker',
			'angularPromiseButtons',
			'ui.select',
			'uiGmapgoogle-maps',
			'ui.tinymce',
			'fixed.table.header',
			'moment-picker',
			'checklist-model',
			'ngFileUpload',
			'ngStorage',
			'bw.paging',
			'highcharts-ng'
		]);

	angular.module('bmsApp.directives', []);

	app.config(function myAppConfig($stateProvider
		, $urlRouterProvider
		, $animateProvider
		, IdleProvider
		, $httpProvider
		, KeepaliveProvider
		, $jqueryValidateProvider
		, $urlMatcherFactoryProvider
		, uiGmapGoogleMapApiProvider
		, angularPromiseButtonsProvider
		, $localStorageProvider
		, $qProvider) {
		$stateProvider

			.state('main', {
				abstract: true,
				templateUrl: 'ng/layout/main.html',
				data: {requireLogin: true}
			})

			.state('breakout', {
				abstract: true,
				templateUrl: 'ng/layout/breakout.html',
				data: {requireLogin: true}
			})

			.state('cmsMain', {
				abstract: true,
				templateUrl: 'ng/cms/layout/main.html',
				data: {requireLogin: true}
			});

		$localStorageProvider.setKeyPrefix('bms-');

		$urlRouterProvider.otherwise('404');

		angularPromiseButtonsProvider.extendConfig({
			spinnerTpl: '<span class="btn-spinner"></span>',
			disableBtn: true,
			btnLoadingClass: 'is-loading',
			addClassToCurrentBtnOnly: false,
			disableCurrentBtnOnly: false,
			minDuration: false,
			CLICK_EVENT: 'click',
			CLICK_ATTR: 'ngClick',
			SUBMIT_EVENT: 'submit',
			SUBMIT_ATTR: 'ngSubmit'
		});

		// $qProvider.errorOnUnhandledRejections(false);  // possibly required for later versions of angular

		// accept trailing slashes in url
		$urlMatcherFactoryProvider.strictMode(false);
		$httpProvider.interceptors.push('APIInterceptor');

		IdleProvider.idle(7140); // 7140 (119 minutes)  (119 so we can forecably close the connection server side first)
		IdleProvider.timeout(120); // timeout after idle-warn (in secs)
		KeepaliveProvider.interval(120); // how often we check for notifications

//		$animateProvider.classNameFilter(/bi-animate/);

		$jqueryValidateProvider.setDefaults({
			ignore: ":hidden:not(select)",
			highlight: function (element) {

				var angularEl = angular.element(element);
				if (angularEl.attr('type') == 'radio') {
					angularEl.parents('.form-group')
						.css('border', '1px solid red');
				}
				else {
					if ($(element)
							.closest('.form-group').length === 0) {
						$(element)
							.addClass('has-error');
					}
					else {
						$(element)
							.closest('.form-group')
							.addClass('has-error');
					}
				}
			},
			unhighlight: function (element) {

				var angularEl = angular.element(element);
				if (angularEl.attr('type') == 'radio') {
					angularEl.parents('.form-group')
						.css('border', 'none');
				}
				else {
					if ($(element)
							.closest('.form-group').length === 0) {
						$(element)
							.removeClass('has-error');
					}
					else {
						$(element)
							.closest('.form-group')
							.removeClass('has-error');
					}
				}
			},
			errorElement: 'span',
			errorClass: 'help-block',
			errorPlacement: function (error, element) {

				if (element.is("[chosen]")) {
					error.insertAfter(element.next());
				}
				else if (element.is("[type=checkbox], [type=radio]")) {
//					error.insertAfter(element.parents('.input-group'));
					element.parents('.form-group')
						.append(error);

				}
				else {

					if (element.parent('.input-group').length) {
						error.insertAfter(element.parent());
					}
					else {
						error.insertAfter(element);
					}
				}
			}
//			errorLabelContainer: "#errors",
		});

		$jqueryValidateProvider.addMethod("postcodeUK", function (value, element) {
			return this.optional(element) || /^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$/i.test(value);
		}, "Please specify a valid UK postcode");

		$jqueryValidateProvider.addMethod('timeBefore', function (value, element, params) {
			var start = moment($(element).val(), 'HH:mm');
			var end = moment($(params).val(), 'HH:mm');
			return this.optional(element) || end.isAfter(start);
		}, "Must be before {0}");

		$jqueryValidateProvider.addMethod('timeAfter', function (value, element, params) {
			var start = moment($(params).val(), 'HH:mm');
			var end = moment($(element).val(), 'HH:mm');
			return this.optional(element) || end.isAfter(start);
		}, "Must be after {0}");

		uiGmapGoogleMapApiProvider.configure({
			key: 'AIzaSyBuw98eABqXTBr9w0ky90WKV-GV04voJPs',

			// v: '3.25', //defaults to latest 3.X anyhow
			//libraries: 'weather,geometry,visualization'
		});

	});

	app.run([
		'$window',
		'$httpParamSerializer',
		'$mdDialog',
		'$ngBootbox',
		'$rootScope',
		'$location',
		'AuthService',
		'CustomerSvc',
		'ConfigService',
		'InstanceSvc',
		'$state',
		'amMoment',
		'AppState',
		'$modal',
		'$modalStack',
		'$timeout',
		'$interpolate',
		'uiTimepickerConfig',
		'ngTableDefaults',
		'uiCalendarConfig',
		'$localStorage',
		'$http',
		'FranchiseSvc',
		function ($window,
				  $httpParamSerializer,
				  $mdDialog,
				  $ngBootbox,
				  $rootScope,
				  $location,
				  AuthService,
				  CustomerSvc,
				  ConfigService,
				  InstanceSvc,
				  $state,
				  amMoment,
				  AppState,
				  $modal,
				  $modalStack,
				  $timeout,
				  $interpolate,
				  uiTimepickerConfig,
				  ngTableDefaults,
				  uiCalendarConfig,
				  $localStorage,
				  $http) {

			/* set default ngTable params and settings */
			ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, {
				count: 100
			});

			// Set default uiCalendar options
			uiCalendarConfig.locale = 'en-GB'; // mainly for Monday start of week

			// Check if the system is in the 'welcome' state, ie. not yet setup
			// AppState.get()
			//     .then(function (data) {
			//         $rootScope.bms2modules = data.bms2modules;
			//
			//        // AuthService.authRedirect();
			//
			//     }, function (error) {
			//         $scope.errors = error;
			//     });

			amMoment.changeLocale('en_GB');

			$rootScope.pageTitle = 'BMS';

			app.config(function (uiSelectConfig) {
				uiSelectConfig.theme = 'bootstrap';
			});

			$http.defaults.headers.common = {'FranchiseInstanceId': $localStorage.currentInstance ? $localStorage.currentInstance.id : ''};
			$rootScope.$state = $state;

			var bypass = false;
			$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
				$rootScope.isError = false;
				$rootScope.errorCode = 200;

				if (toState.name == 'logout') {
					return;
				}

				if (!angular.isDefined($localStorage.currentInstance) && toState.name != 'login' && toState.name != 'instanceSelection') {
					$state.go('instanceSelection', toParams)
					return;
				}

				const disableBMS = true;
				if(angular.isDefined($localStorage.currentInstance) && disableBMS){
					if(($localStorage.currentInstance.licence_type.value == 'mm' || $localStorage.currentInstance.licence_type.value == 'sm')){
						if (toState.name != 'login' && toState.name != 'maintenanceMode') {
							$state.go('maintenanceMode', toParams)
							return;
						}
					}
				}



				if (bypass !== true) {
					event.preventDefault();
					// TODO: Redirect from main state to a default location
					AuthService.getUser()
						.then(function (user) {
							var authenticationPass, rolePass, authorisationPass;

							var stateData = angular.isObject(toState.data) ? toState.data : {};
							var authenticated = angular.isObject(user);
							var userRoles = angular.isObject(user) ? user.role_list : [];
							var userPermissions = angular.isObject(user) ? user.permission_list : [];
							authenticationPass = (!stateData.requireLogin || (stateData.requireLogin && authenticated));
							rolePass = (angular.isUndefined(stateData.roles) || _.intersection(stateData.roles, userRoles).length > 0);
							authorisationPass = (angular.isUndefined(stateData.permissions) || _.intersection(stateData.permissions, userPermissions).length > 0);

							if (authenticationPass && rolePass && authorisationPass) {
								bypass = true;
								$state.go(toState, toParams)
									.then(function () {
										// re-enable auth checks once state reached
										bypass = false;
										angular.extend($rootScope, {
											loggedInUser: user
										});

									});
							}
							else {

								if (!authenticationPass) {
									var redirect = $state.href(toState, toParams);
									$state.go('login', {
										redirect: redirect
									});
									console.warn('AUTHENTICATION REQUIRED');
								}
								else {
									$state.go('main.403', null, {
										location: false
									});
									console.error('AUTHORISATION FAILED');
								}
							}

						});
				}

			});


			$rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
				if ($modalStack.getTop() && !confirm('You are in the middle of something, if you proceed all changed will be lost. Continue?')) {
					event.preventDefault(); // This prevents the navigation from happening
				}
				else {
					$modalStack.dismissAll(); // Close all the open modals
				}
			});

			$rootScope.$on('500', function (event, response) {
			});
			$rootScope.$on('401_unauthorised', function (event, response) {
			});
			$rootScope.$on('403_forbidden', function (event, response) {
			});
			$rootScope.$on('404', function (event, response) {
			});

			PNotify.prototype.options.styling = "bootstrap3";

			angular.extend(uiTimepickerConfig, {
				asMoment: true
			});

			amMoment.changeTimezone('Europe/London');
			//moment.tz.setDefault('Europe/London');

			/* Copy useful angular functions to scope -------------------------------------------------*/

			$rootScope.isNumber = angular.isNumber;
			$rootScope.isDefined = angular.isDefined;
			$rootScope.isUndefined = angular.isUndefined;
			$rootScope.isString = angular.isString;
			$rootScope.isObject = angular.isObject;
			$rootScope.isArray = angular.isArray;

			/* Global config ---------------------------------------------------------------*/
			$rootScope.config = ConfigService.config;

			/* License helper functions ---------------------------------------------------------------*/
			$rootScope.isMM = InstanceSvc.instance.isMM;
			$rootScope.isTG = InstanceSvc.instance.isTG;
			$rootScope.isSM = InstanceSvc.instance.isSM;
			$rootScope.isCS = InstanceSvc.instance.isCS;
			$rootScope.isRB = InstanceSvc.instance.isRB;
			$rootScope.isFM = InstanceSvc.instance.isFM;
			$rootScope.isTrainingUser = InstanceSvc.instance.isTrainingUser;
			$rootScope.isSMNetwork = InstanceSvc.instance.isSMNetwork;
			$rootScope.isDumbNetwork = InstanceSvc.instance.isDumbNetwork;

			// let currentInstance = InstanceSvc.instance.currentFranchiseInstance();
			// if (angular.isDefined(currentInstance.licences)) {
			// 	angular.forEach(currentInstance.licences, function (lic) {
			// 		console.log(lic.license_type.label);
			// 			if (angular.isObject(lic.license_sub_type)) {
			// 				console.log(lic.license_sub_type.label);
			// 			}
			// 			console.log('------------');
			// 	});
			// }

			$rootScope.hasSubNetwork = InstanceSvc.instance.hasSubNetwork;
			$rootScope.allLicences = InstanceSvc.instance.getAll;

			// console.log(InstanceSvc.instance.isDumbNetwork());

			$rootScope.hasPermission = AuthService.hasPermission;

			// This is a hack!
			$rootScope.goToReportList = function() {
				if ($state.is('main.reports.index')) {
					$window.location.reload();
				}
				else {
					$state.go('main.reports.index');
				}
			};

			/* Function to return whether we're currently using a particular bms2 module or bms1 module */
			$rootScope.isBms2Module = AuthService.isBms2Module;

			/* Merrymaids pay helper functions ---------------------------------------------------------------*/
			$rootScope.isMMPayByPercentage = InstanceSvc.instance.isMMPayByPercentage;
			$rootScope.isMMPayByHourly = InstanceSvc.instance.isMMPayByHourly;
			$rootScope.isMMPayByAttendance = InstanceSvc.instance.isMMPayByAttendance;
			$rootScope.isMMPayByJobDuration = InstanceSvc.instance.isMMPayByJobDuration;

			$rootScope.printTGAnalysisForm = function (type, object, $event) {
				if ($event !== undefined) {
					$event.stopPropagation();
				}
				var confirm = $mdDialog.confirm()
					.title('Save Analysis Form')
					.textContent('Would you like to save a copy of this analysis form in notes?')
					.ariaLabel('Save Analysis From')
					.ok('Yes please')
					.cancel('No thanks');
				var urlParams = {
					type: type,
					save: false,
				};
				var idName;
				switch (type) {
					case 'blank':
						idName = 'customer_id';
						break;
					case 'enquiry':
						idName = 'enquiry_id';
						break;
					case 'filled':
						idName = 'quote_id';
						break;
					case 'empty':
						break;
					default:
						console.error('Invalid analysis form type selected: ' + type);
						break;
				}
				if (angular.isObject(object)) {
					urlParams[idName] = object.id;
					if (type === 'filled') {
						$mdDialog.show(confirm)
							.then(function () {
								urlParams.save = true;
								$window.open('trugreen/analysis-form?' + $httpParamSerializer(urlParams), '_blank');
							}, function () {
								$window.open('trugreen/analysis-form?' + $httpParamSerializer(urlParams), '_blank');
							});
					} else {
						$window.open('trugreen/analysis-form?' + $httpParamSerializer(urlParams), '_blank');
					}
				}
				else {
					urlParams.save = false;
					$window.open('trugreen/analysis-form?' + $httpParamSerializer(urlParams), '_blank');
				}

			};

			$rootScope.printTGQuoteForm = function (jobId) {
				var confirm = $mdDialog.confirm()
					.title('Save Quote')
					.textContent('Would you like to save a copy of this quote in notes?')
					.ariaLabel('Save quote')
					.ok('Yes please')
					.cancel('No thanks');

				$mdDialog.show(confirm)
					.then(function () {
						$window.open('trugreen/quote-form?type=filled&save=true&quote_id=' + jobId, '_blank');
					}, function () {
						$window.open('trugreen/quote-form?type=filled&save=false&quote_id=' + jobId, '_blank');
					});
			};

			$rootScope.printSMQuoteForm = function (jobId) {
				var confirm = $mdDialog.confirm()
					.title('Save Quote')
					.textContent('Would you like to save a copy of this quote in notes?')
					.ariaLabel('Save quote')
					.ok('Yes please')
					.cancel('No thanks');

				$mdDialog.show(confirm)
					.then(function () {
						$window.open('sm/quote-form?type=filled&save=true&quote_id=' + jobId, '_blank');
					}, function () {
						$window.open('sm/quote-form?type=filled&save=false&quote_id=' + jobId, '_blank');
					});
			};

			$rootScope.printMMQuoteForm = function (type, object) {
				var idName;
				switch (type) {
					case 'blank':
						idName = 'customer_id';
						break;
					case 'enquiry':
						idName = 'enquiry_id';
						break;
					case 'filled':
						idName = 'quote_id';
						break;
					case 'empty':
						break;
					default:
						console.error('Invalid quote form type selected: ' + type);
						break;
				}

				if ((type == 'blank' || type == 'enquiry') && angular.isObject(object)) {

					var modalInstance = $modal.open({
						templateUrl: 'ng/merrymaids/job/templates/BlankQuoteFormSelectionModal.html',
						controller: 'MMBlankQuoteFormSelectionModalCtrl'
					});

					modalInstance.result.then(function (selection) {
						var templateIdStr = (angular.isObject(selection.houseTemplate)) ? '&templateId=' + selection.houseTemplate.id : '';
						$window.open('merrymaids/quote-form?type=' + type + '&' + idName + '=' + object.id + '&rooms=' + selection.type + templateIdStr, '_blank');
					});
				}
				else {
					var confirm = $mdDialog.confirm()
						.title('Save Quote')
						.textContent('Would you like to save a copy of this quote in notes?')
						.ariaLabel('Save quote')
						.ok('Yes please')
						.cancel('No thanks');

					$mdDialog.show(confirm)
						.then(function () {
							if (angular.isObject(object)) {
								$window.open('merrymaids/quote-form?type=' + type + '&save=true&' + idName + '=' + object.id, '_blank');
							}
							else {
								$window.open('merrymaids/quote-form?type=' + type + '&save=true', '_blank');
							}
						}, function () {
							if (angular.isObject(object)) {
								$window.open('merrymaids/quote-form?type=' + type + '&' + idName + '=' + object.id, '_blank');
							}
							else {
								$window.open('merrymaids/quote-form?type=' + type, '_blank');
							}
						});

				}
			};

			$rootScope.printInvoice = function (invoice) {
				if (angular.isObject(invoice)) {
					if (invoice.class === 'App\\Models\\Merrymaids\\Invoice') {
						$window.open('merrymaids/invoice/' + invoice.id, '_blank');
					}
					if (invoice.class === 'App\\Models\\Sm\\Invoice') {
						$window.open('sm/invoice/' + invoice.id, '_blank');
					}
					else if (invoice.class === 'App\\Models\\Trugreen\\Invoice') {
						$window.open('trugreen/invoice/' + invoice.id, '_blank');
					}
				}
			};

			$rootScope.repeatEnquiry = function(customer) {
				CustomerSvc.showRepeatEnquiryModal(customer).then((response) => {
				});
			}

		}
	]);

})();

function precisionRound(number, precision) {
	var factor = Math.pow(10, precision);
	var tempNumber = number * factor;
	var roundedTempNumber = Math.round(tempNumber);
	return roundedTempNumber / factor;
}

